import axios from "axios";
import { req } from "@/api/api_request";

// 获取微站设备分组树
function getGroupTree(group_id) {
  let url = `station/get-group-tree?group_id=${group_id}`;
  return req.get(url);
}

// 获取标站设备信息
function getGroupTreeSn(regionId) {
  let url = `https://gf.novaecs.com/api/gf_manage/station/?region_id=${regionId}&station_type=水质`;
  return axios.get(url);
}

function getGfStationListData(regionId, data_type, time) {
  data_type = data_type.replaceAll("temperature", "water_temperature");
  let url = `http://gf.novaecs.com/api/gf_manage/station_data/?region_id=${regionId}&station_type=水质&data_type=${data_type}`;
  // 查询某个时间点数据
  if (time) {
    url += `&start_t=${time}`;
  }
  return axios.get(url);
}

// 获取当前时间数据
function getCurrentData(group_id, time_type, dev_types, station_name, quxian) {
  let url = `station/get-current-data?group_id=${group_id}&time_type=${time_type}`;
  if (dev_types) {
    url += `&dev_types=${dev_types}`;
  }
  if (station_name) {
    url += `&station_name=${station_name}`;
  }
  if (quxian) {
    url += `&quxian=${quxian}`;
  }
  return req.get(url);
}

// 获取微站历史数据
function getHistoryData(
  group_id,
  station_ids,
  time_type,
  data_type,
  start_time,
  end_time,
  dev_types
) {
  let url = `station/get-history-data?group_id=${group_id}&time_type=${time_type}&start_time=${start_time}&end_time=${end_time}&data_source=calied`;
  if (data_type) {
    url += `&data_type=${data_type}`;
  }
  if (station_ids) {
    url += `&station_ids=${station_ids}`;
  }
  if (dev_types) {
    url += `&dev_types=${dev_types}`;
  }
  return req.get(url);
}

// 获取微站历史数据(时间点)
function getHistoryDataCurr(
  group_id,
  station_ids,
  time_type,
  time,
  dev_types,
  station_name,
  quxian
) {
  let url = `station/get-history-data-curr?group_id=${group_id}&time_type=${time_type}&time=${time}`;
  if (station_ids) {
    url += `&station_ids=${station_ids}`;
  }
  if (dev_types) {
    url += `&dev_types=${dev_types}`;
  }
  if (station_name) {
    url += `&station_name=${station_name}`;
  }
  if (quxian) {
    url += `&quxian=${quxian}`;
  }
  return req.get(url);
}

// 获取标站数据
function getGfSnData(sn, startTime, endTime, dataType, timeType) {
  dataType = dataType.replaceAll("temperature", "water_temperature");
  let url = `https://gf.novaecs.com/api/gf_manage/getStationData/?sn=${sn}&start_t=${startTime}&end_t=${endTime}&data_type=${dataType}&time_type=${timeType}`;
  return axios.get(url);
}

export {
  getGroupTree,
  getGroupTreeSn,
  getHistoryData,
  getHistoryDataCurr,
  getGfSnData,
  getCurrentData,
  getGfStationListData
};
